import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { motion } from 'framer-motion';
import Cookies from "js-cookie";


const LoadingOverlay = ({ loading }) => {
  if (!loading) return null;

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="animate-spin h-8 w-8 border-4 border-orange-500 border-t-transparent rounded-full"/>
    </div>
  );
};

const WorkspacesPage = () => {
  const [workspaces, setWorkspaces] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const base_url = process.env.REACT_APP_BASE_URL;

  const MAX_RETRIES = 5;

  const fetchDataWithRetry = async (setWorkspaces, base_url) => {
    let attempts = 0;
  
    while (attempts < MAX_RETRIES) {
      try {
        const response = await axios.get(`${base_url}/get-workspaces`, {
            headers: { userId: "c05b18fc-453f-43f2-9c58-39cf5dc637fb"},
        });
        setWorkspaces(response.data);
      } catch (error) {
        attempts++;
        console.error(`Attempt ${attempts} failed:`, error);
        if (attempts === MAX_RETRIES) {
          console.error("Max retries reached. Failed to fetch data.");
        } else {
          console.log("Tried again");
          await new Promise((resolve) => setTimeout(resolve, 500));
        }
      } finally {
        setLoading(false);
      }
    }
  };
  
  useEffect(() => {
    fetchDataWithRetry(setWorkspaces, base_url);
  }, []);

  // useEffect(() => {
  //   const fetchWorkspaces = async () => {
  //     try {
  //       const response = await axios.get(`${base_url}/get-workspaces`, {
  //           headers: { userId: "c05b18fc-453f-43f2-9c58-39cf5dc637fb"},
  //       });
  //       setWorkspaces(response.data);
  //     } catch (err) {
  //       console.error("Error fetching workspaces:", err);
  //       setError("Failed to fetch workspaces. Please try again.");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchWorkspaces();
  // }, [base_url]);

  if (loading) {
    return <LoadingOverlay loading={loading} />;
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-red-500">{error}</p>
      </div>
    );
  }

  function formatDate(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  }

  return (
    <motion.div 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="min-h-screen p-8"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-5xl md:text-6xl font-semibold uppercase leading-snug tracking-wide">
            All Ideas
          </h1>
          <button
            onClick={() => window.location.href = '/'}
            className="bg-orng hover:bg-orange-600 text-white py-2 px-6 rounded-full transition-colors"
          >
            Back to Home
          </button>
        </div>

        {workspaces.length === 0 ? (
          <div className="text-center py-12">
            <p className="text-xl text-gray-600">No ideas found. Start by creating a new business idea!</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {workspaces.map((workspace) => (
              <motion.div 
                key={workspace.workspace_id}
                whileHover={{ scale: 1.02 }}
                className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow cursor-pointer p-6 border border-gray-200"
                onClick={() => {
                  Cookies.set("workspaceId", workspace.workspace_id, { expires: 7 });
                  window.location.href = '/overview';
                }}
              >
                <div className="mb-4">
                  <h2 className="text-xl font-semibold text-orange-500 mb-2">
                    {workspace.one_liner}
                  </h2>
                  <p className="text-sm text-gray-500">
                    Created on {formatDate(workspace.created_at)}
                  </p>
                </div>
                <div>
                  <p className="text-gray-700 overflow-hidden line-clamp-3">
                    {workspace.description}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default WorkspacesPage;